import React, { useState } from 'react';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import Toolbar from '@material-ui/core/Toolbar';
import clsx from 'clsx';
import { useStyles } from './DialogImpressaoStyles';
import AppBar from '@material-ui/core/AppBar/AppBar';
import DialogContent from '@material-ui/core/DialogContent/DialogContent';
import Grid from '@material-ui/core/Grid';
import DialogActions from '@material-ui/core/DialogActions/DialogActions';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog/Dialog';
import Slide from '@material-ui/core/Slide';
import { useMediaQuery, useTheme } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete/Autocomplete';
import CloseIcon from '@material-ui/icons/Close';
import { getRelatorioListagemFiliados, getRelatorioResumoVisitaFiliado } from '../../../../services/RelatorioService';
import { MessageValues } from '../../../../values/MessageValues';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

function DialogImpressao(props) {
  const {
    filiacaoStatus,
    open,
    setOpen,
    setShowMessageSnack,
    setMessageSnack,
    setTypeSnack,
    setLoading
  } = props;
  const [statusSelecionado, setStatusSelecionado] = useState();
  const classes = useStyles();
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'), {
    defaultMatches: true
  });


  function fecharDialog(event) {
    event.preventDefault();
    setOpen(false);
  }

  async function downloadPDF(event) {
    try{
      event.preventDefault();
      setOpen(false);
      setLoading(true);
      let filtros = {
        idFiliacaoStatus: statusSelecionado ? statusSelecionado.idFiliacaoStatus : undefined
      };
      const relatorio = await getRelatorioListagemFiliados(filtros);
      if(relatorio.isSuccess){
        const file = new Blob(
          [relatorio.result],
          {type: 'application/pdf'});
        const fileURL = window.URL.createObjectURL(file);
        const link = document.createElement('a');
        link.href = fileURL;
        link.setAttribute('download', `listagem_filiados.pdf`);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        setLoading(false);
      }
      else{
        setOpen(true);
        setLoading(false);
        setTypeSnack('error');
        setMessageSnack(relatorio.message);
        setShowMessageSnack(true);
      }
    }
    catch (e) {
      setOpen(true);
      setLoading(false);
      setTypeSnack('error');
      setMessageSnack(MessageValues.erro_catch + ' Detalhamento erro: ' + e.toString());
      setShowMessageSnack(true);
    }
  }


  return (
    <Dialog
      open={open}
      fullScreen={!isDesktop}
      TransitionComponent={Transition}
      className={clsx({
          [classes.root]: true
        }
      )}
    >
      <AppBar position={'relative'} className={classes.appBar} color={'transparent'} variant={'outlined'}>
        <Toolbar>
          <Typography variant="h6" className={classes.title} >Impressão</Typography>
          <IconButton edge="end" color="primary" onClick={e => fecharDialog(e)} aria-label="close">
            <CloseIcon />
          </IconButton>
        </Toolbar>
      </AppBar>
      <DialogContent>
        <Grid
          container
          spacing={2}
        >
          <Grid
            item
            md={12}
            xs={12}
          >
            <Typography
              color="textSecondary"
              gutterBottom
              variant="body2"
              component='h5'
              className={clsx({
                [classes.textoInstrucao]: true
              })}
            >
              Informe os filtros para imprimir a relação de filiados
            </Typography>
          </Grid>
          <Grid
            item
            md={12}
            xs={12}
          >
            <Autocomplete
              size={'small'}
              id="autocomplete_status"
              value={statusSelecionado}
              onChange={(event, value) => setStatusSelecionado(value)}
              getOptionSelected={(option, value) => option.idFiliacaoStatus === option.idFiliacaoStatus}
              getOptionLabel={option => option.descricao}
              options={filiacaoStatus}
              renderInput={params => (
                <TextField
                  {...params}
                  label="Status de filiado"
                  fullWidth
                  value={statusSelecionado}
                  margin={'dense'}
                  variant="outlined"
                  helperText={'Selecione o status dos filiados que deseja imprimir. Deixe esse campo sem preenchimento caso não queira filtrar os filiados.'}
                />
              )}
            />

          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions
      >
        <Grid
          container
          spacing={2}
        >
          <Grid
            item
            md={10}
            xs={12}

          >
          </Grid>
          <Grid
            item
            md={12}
            xs={12}
            className={clsx({
              [classes.gridBotaoSalvar]: true
            })}
          >
            <Button
              fullWidth
              variant={'contained'}
              color={'primary'}
              onClick={e => downloadPDF(e)}
            >
              IMPRIMIR
            </Button>
          </Grid>
        </Grid>
      </DialogActions>
    </Dialog>
  );
};

export default DialogImpressao;
